import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { UiButtonFunctionComponent } from '@cynteka/ui-kit';

import {
    ChatFileAttachmentItem,
    ChatFileMessagePayload,
    ChatMessage,
} from '../../../../types/chat-session.types';
import { MarkdownPipe } from '../../../../pipes/markdown.pipe';

@Component({
    selector: 'chat-attachment-message',
    standalone: true,
    imports: [CommonModule, UiButtonFunctionComponent, MarkdownPipe],
    templateUrl: './chat-attachment-message.component.html',
    styleUrls: ['./chat-attachment-message.component.scss'],
})
export class ChatAttachmentMessageComponent {
    @Input() public message!: ChatMessage<'file', ChatFileMessagePayload>;

    public get files(): ChatFileAttachmentItem[] {
        return this.message?.payload?.files ?? [];
    }

    public get isTranscribing(): boolean {
        return Boolean(this.message?.payload?.transcribing);
    }

    public getFileSizeLabel(size: number): string {
        if (size < 1024) {
            return `${size} Б`;
        }

        if (size < 1024 * 1024) {
            return `${(size / 1024).toFixed(1)} КБ`;
        }

        return `${(size / (1024 * 1024)).toFixed(1)} МБ`;
    }

    public trackByFile(_index: number, file: ChatFileAttachmentItem): string {
        return `${file.name}-${file.size}-${file.fileId ?? ''}`;
    }
}
